import { useReveal, Image, VideoLoop } from '@ccg/core';
import React$1 from 'react';
import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import Link$1 from '../../basics/Link/Link.js';
import Typography$1 from '../../basics/Typography/Typography.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import StyledTeaser from './Teaser.style.js';
import SpecialHeadline$1 from '../SpecialHeadline/SpecialHeadline.js';
import Tags$1 from '../Tags/Tags.js';

const Teaser = ({
  headline,
  subline,
  image,
  topic,
  logo,
  city,
  street,
  tags,
  video,
  link,
  index,
  postDate,
  featured,
  phoneNumber,
  email
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledTeaser, {
    className: "teaser",
    featured: featured,
    hasMedia: image || video,
    isEven: index % 2 === 0,
    logoHorizontal: logo ? logo.width > logo.height : undefined,
    ref: ref,
    isVisible: isVisible
  }, /*#__PURE__*/React$1.createElement(Link$1, _extends({
    className: "teaser__link",
    noHover: true
  }, link), image || video ? /*#__PURE__*/React$1.createElement("div", {
    className: "teaser__media"
  }, /*#__PURE__*/React$1.createElement(RevealBox$1, {
    isVisible: isVisible,
    direction: index % 2 === 0 ? 'left' : 'right'
  }, image && !video ? /*#__PURE__*/React$1.createElement(Image, {
    src: image.src || image.url,
    srcset: image.srcset,
    alt: image.alt,
    ratio: "3:2",
    sizes: "(min-width: 768px) 50vw, 100vw",
    lazy: true
  }) : null, video ? /*#__PURE__*/React$1.createElement(VideoLoop, {
    src: video.url,
    loop: true
  }) : null)) : null, /*#__PURE__*/React$1.createElement("div", {
    className: "teaser__content"
  }, (topic || postDate) && !logo && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "teaser__topic"
  }, topic || postDate), logo && /*#__PURE__*/React$1.createElement(Image, {
    src: logo.url,
    className: "teaser__logo"
  }), /*#__PURE__*/React$1.createElement(SpecialHeadline$1, {
    as: "h2",
    variant: "intro",
    text: headline,
    className: "teaser__headline"
  }), subline && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "teaser__subline"
  }, subline), street && street.trim() !== '' && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "teaser__street"
  }, street), city && city.trim() !== '' && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "teaser__city"
  }, city), phoneNumber && phoneNumber.trim() !== '' && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "teaser__phoneNumber"
  }, phoneNumber), email && email.trim() !== '' && /*#__PURE__*/React$1.createElement(Typography$1, {
    className: "teaser__email"
  }, email))), tags && tags.length > 0 && /*#__PURE__*/React$1.createElement("div", {
    className: "teaser__tags"
  }, /*#__PURE__*/React$1.createElement(Tags$1, {
    horizontal: true,
    tags: tags,
    variant: "small"
  })));
};

Teaser.propTypes = {
  featured: PropTypes$1.bool,
  postDate: PropTypes$1.string,
  topic: PropTypes$1.string,
  headline: PropTypes$1.string.isRequired,
  subline: PropTypes$1.string,
  link: PropTypes$1.shape(),
  image: PropTypes$1.shape({
    src: PropTypes$1.string,
    url: PropTypes$1.string,
    srcset: PropTypes$1.shape(),
    alt: PropTypes$1.string
  }),
  index: PropTypes$1.number,
  tags: PropTypes$1.arrayOf(PropTypes$1.shape({
    title: PropTypes$1.string,
    id: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number])
  })),
  video: PropTypes$1.shape({
    url: PropTypes$1.string
  }),
  logo: PropTypes$1.string,
  street: PropTypes$1.string,
  city: PropTypes$1.string,
  phoneNumber: PropTypes$1.string,
  email: PropTypes$1.string
};
Teaser.defaultProps = {
  featured: false,
  image: null,
  index: 0,
  postDate: null,
  subline: null,
  tags: [],
  topic: null,
  link: {},
  video: null,
  logo: undefined,
  street: undefined,
  city: undefined,
  phoneNumber: undefined,
  email: null
};

export default Teaser;
